<template>
  <el-container>
    <el-header>
      <el-row>
        <el-col :span="2">
          <img src="../assets/RMS-logo.png" width="100" height="50" />
        </el-col>
        <el-col :span="3">产品注册升级管理系统</el-col>
        <el-col :span="2" :offset="17">
          <el-dropdown>
            <span class="el-dropdown-link">
              {{username}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="exit">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
      </el-row>
    </el-header>
    <el-container>
      <el-aside width="200px">
        <el-menu :default-active="$route.path" router>
          <template v-for="(item,index) in $router.options.routes">
            <template v-for="(subitem,subIndex) in item.children" v-if="!item.hidden">
              <el-menu-item v-if="!subitem.hidden" :index="subitem.path">
                <i :class="subitem.icon"></i>{{subitem.name}}</el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <el-container class="content-bg">
        <el-main>
            <router-view/>
        </el-main>
      </el-container>
    </el-container>
    <el-footer style="text-align:center;">© 2017 Copyrights groupinno</el-footer>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      username:''
    };
  },
  methods:{
    exit(){
      this.$confirm("即将退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "退出登录成功！"
          });
          this.$router.push({path:'/login'});
        }).catch(()=>{
          this.$message({
            type: "info",
            message: "退出登录取消！"
          });
        });
    }
  },
  mounted(){
    this.username = sessionStorage.getItem('username');
    if (!this.username) {
      this.$router.push({path:'/login'});
    }
  }
};
</script>

<style scoped lang="less">
.el-header {
  line-height: 60px;
  .el-dropdown{
    cursor: pointer;
  }
}
  .el-aside {
    border-top: 2px solid #ddd;
    border-bottom: 2px solid #ddd;
    height: 84vh;
    .el-menu {
      border-right: 0;
      text-align: center;
      .is-active{
        background-color:#409EFF;
        color:#fff;
      }
    }
  }
  .content-bg{
    background-color:#EBECEE;
    .el-main{
      margin:20px;
      box-shadow: 0 0 5px #ddd;
      background-color: #fff;
    }
  }
.el-footer {
  line-height: 60px;
}
</style>
<style>
body {
  margin: 0;
  padding: 0;
}
.el-table{
  height: 61vh!important;
  overflow-y: auto!important;
}
.el-table td, .el-table th{
  padding:5px 0!important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue